var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrgchartUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "axgxnb61ya"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 7273",
    style: {
      fill: "#d5dadd"
    },
    d: "M0 0h44v38.107H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 13448"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 176",
    cx: 22,
    cy: 22,
    r: 22,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8179"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8112",
    style: {
      clipPath: "url(#axgxnb61ya)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5945",
    d: "M17.875 32.915v-3.229a1.688 1.688 0 0 1-.884-.539c-.728-.742-1.284-2.087-2.1-3.069-.671-.843-1.507-1.09-1.813-1.984a4.823 4.823 0 0 1-.216-1.632 2.6 2.6 0 0 1 1.225-2.352c0-1.054-.039-2.092-.015-3.033a9.031 9.031 0 0 1 .662-4.145 3.192 3.192 0 0 1 1.97-1.7 2.174 2.174 0 0 1 .289-.066c1.678-.478 3.662-.294 5.321-1.411h.986c1.176.14 1.232 1.568 2.3 1.975a2.233 2.233 0 0 0 .759.132c.382 0 .713-.066 1.078-.066a1.616 1.616 0 0 1 .958.272c1.921 1.313.862 5.409.97 8.207.122.522 1.034.289 1.173.818a17.664 17.664 0 0 1 0 3.616c-2.241.894-2.638 3.618-4.458 4.931-1.323 5 2.033 5.145 5.774 5.911a9.279 9.279 0 0 1 5.126 2.559 22 22 0 1 0-30.25-.273c2.6-2.268 7.607-1.743 10.261-3.964a4.062 4.062 0 0 0 .884-.958",
    transform: "translate(0 -.001)",
    style: {
      fill: "#d5dadd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 13416"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8112",
    style: {
      clipPath: "url(#axgxnb61ya)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5945",
    d: "M17.875 32.915v-3.229a1.688 1.688 0 0 1-.884-.539c-.728-.742-1.284-2.087-2.1-3.069-.671-.843-1.507-1.09-1.813-1.984a4.823 4.823 0 0 1-.216-1.632 2.6 2.6 0 0 1 1.225-2.352c0-1.054-.039-2.092-.015-3.033a9.031 9.031 0 0 1 .662-4.145 3.192 3.192 0 0 1 1.97-1.7 2.173 2.173 0 0 1 .289-.066c1.678-.478 3.662-.294 5.321-1.411h.986c1.176.14 1.232 1.568 2.3 1.975a2.233 2.233 0 0 0 .759.132c.382 0 .713-.066 1.078-.066a1.616 1.616 0 0 1 .958.272c1.921 1.313.862 5.409.97 8.207.122.522 1.034.289 1.173.818a17.664 17.664 0 0 1 0 3.616c-2.241.894-2.638 3.618-4.458 4.931-1.323 5 2.033 5.144 5.774 5.911a9.279 9.279 0 0 1 5.126 2.559 22 22 0 1 0-30.25-.273c2.6-2.268 7.607-1.743 10.261-3.964a4.062 4.062 0 0 0 .884-.958",
    transform: "translate(0 -.001)",
    style: {
      fill: "#d5dadd"
    }
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrgchartUser);
export default __webpack_public_path__ + "static/media/orgchart-user.131f0084edb3b2a363e413abb869918f.svg";
export { ForwardRef as ReactComponent };